import { render } from "./Thanks.vue?vue&type=template&id=f85678f4&scoped=true"
import script from "./Thanks.vue?vue&type=script&lang=js"
export * from "./Thanks.vue?vue&type=script&lang=js"

import "./Thanks.vue?vue&type=style&index=0&id=f85678f4&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/proship-public-order/proship-public-order/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f85678f4"]])

export default __exports__